<template>
  <div>
    <section class="hero is-white">
      <div class="hero-body">
        <div class="breadcrumb-wrapper">
          <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
          <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/index">Trang chủ</router-link></li>
              <li class="is-active"><a>Admin</a></li>
            </ul>
          </nav>
        </div>
        <div class="container">
          <admin-menu :activeLink="'/import'"/>
          <div class="form-user padding-space no-padding">
            <h2 class="title is-4 has-text-centered">Import</h2>
            <div class="dropbox">
              <div class="row">Select owner: 
                <b-field>
                  <v-select
                    :options="accountList"
                    v-model="owner"
                    class="import__select"
                  />
                </b-field>
              </div>
              <h1>Chọn tập tin csv</h1>
              <input type="file" accept=".csv" @change="onFileChange">
              <div v-if="file">
                <button @click="uploadFile">Tải tập tin</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue"
import vSelect from "vue-select"
import { mapActions } from "vuex"
import ParticipantService from "@/services/ParticipantService"

Vue.component('v-select', vSelect)

export default {
  name: "MultiUserAdd",

  created() {
    this.fetchAccountList().then((result) => {
      const obj = result.data.users.sort((user1, user2) => {
        return user1.username.toLowerCase() < user2.username.toLowerCase() ? -1 : 1
      });
      const data = Object.keys(obj).map((key) =>  obj[key].username);
      this.accountList = data
    })
  },

  data() {
    return {
      file: null,
      owner: '',
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders:{},
      sortKey: '',
      accountList: []
    };
  },
  components: {
    AdminMenu: () => import("./AdminMenu")
  },
  methods: {
    ...mapActions("hostAccount", ["fetchAccountList"]),
    onFileChange(e) {
     let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.file = files[0];
   },
   uploadFile() {
      if(this.owner.length < 1) {
        alert('Xin nhập owner!');
        return
      }
      const vm = this
      var reader = new FileReader();
      reader.readAsText(this.file);
      reader.onload = (event) => {
        var csv = event.target.result;
        const jsonData = vm.csvJSON(csv);
        const data = {data: jsonData, owner: vm.owner}
        ParticipantService
        .createMultiParticipants(data, vm.$store.state.auth.token)
        .then(res => {
          if(!res.data.status) {
            alert(res.data.message);
            return;
          }
          alert(res.data.message);
        })
        .catch(() => {
          alert('Import không thành công!');
        })
      };
      reader.onerror = function(evt) {
        if(evt.target.error.name == "NotReadableError") {
          alert("Can't read file !");
        }
      };

   },
   csvJSON(csv){
      var clean_csv = csv.replace(/(?:\r\n|\r|\n)/g, '|'); 
      var lines=clean_csv.split("|");
      var result = [];
      var headers=lines[0].split(",");

      for(var i=1;i<lines.length;i++){
        var obj = {};
        var currentline=lines[i].split(",");
        for(var j=0;j<headers.length;j++){
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);
      }

      return result; //JSON
    }
  },

  props: {
    currentUser: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.import__select {
  width: 200px;
}
</style>